export default __webpack_public_path__ + "static/media/face_contouring.337646d6.pdf";